<script>
    import { preventDefault } from 'svelte/legacy';

    import { fade } from "svelte/transition";
    import { environment } from "@app/store/envStore.svelte.js";
    import { modalState, hideModal } from "@app/store/modalStore.svelte.js";
    import { autoReplaceState, updateList, createList, removeList } from "@app/store/autoReplaceStore.svelte.js";
    import { toast } from '@zerodevx/svelte-toast';
    import firebase from '@app/configs/firebase.js';
    import {v4 as uuidv4} from 'uuid';
    import * as m from '@app/paraglide/messages.js';
    let userId = environment.online ? firebase.auth().currentUser.uid : null, selectedList = $state(autoReplaceState.length > 0 ? autoReplaceState[0] : null), selectedReplacement = $state(), shortformInput = $state(""), replacementInput = $state("");


    function selectList(list){
        selectedList = list;
        cancelEdit();
    }
    
    function createListHandler(){
        createList(
            {
                id : uuidv4(),
                name : m.unknown(),
                enabled : true,
                uppercase : false,
                replacements : {}
            }, 
            userId
        );

        selectedList = autoReplaceState[autoReplaceState.length-1];

        toast.push(m.new_list_created_success(), {
            classes : ["toast-success"]
        });
    }

    function removeListHandler(listId){        
        removeList(listId, userId);     
        selectedList = autoReplaceState[0];   

        toast.push(m.list_removed_success(), {
            classes : ["toast-success"]
        });
    }

    function toggleList(listInfo){
        updateList({...listInfo, enabled : !listInfo.enabled}, userId);

        if (selectedList.id ===  listInfo.id){
            selectedList.enabled = !selectedList.enabled;
        }
    }

    function addShortform(){
        selectedList.replacements[shortformInput] =  replacementInput;
        updateList(selectedList, userId);
        resetInput();
    }

    function updateReplacement(replacementValue){
        shortformInput = replacementValue;
        replacementInput = selectedList.replacements[replacementValue];
        selectedReplacement = replacementValue;
    }

    function removeReplacement(replacementValue){
        delete selectedList.replacements[replacementValue];
        selectedList = selectedList;
        updateList(selectedList, userId);
        resetInput();
    }

    function updateShortform(){
        delete selectedList.replacements[selectedReplacement];
        selectedList.replacements[shortformInput] =  replacementInput;
        updateList(selectedList, userId);
        cancelEdit();
    }

    function cancelEdit(){
        resetInput();
        selectedReplacement = undefined;
    }

    function resetInput(){
        shortformInput = "";
        replacementInput = "";
    }
</script>

<div
    transition:fade={{ duration: 100 }}
    class="modal {modalState.selected === 'autoReplace' ? 'show d-block' : ''}"
    role="dialog"
    tabindex="-1"
    id="AutoReplaceModal"
    aria-labelledby="autoReplaceTitle"
    aria-describedby="autoReplaceDescription">
    <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="autoReplaceTitle">{m.auto_replacement()}</h4>
                <button
                    type="button"
                    class="btn-close"
                    aria-label={m.close_auto_replace_modal()}
                    onclick={hideModal}
                ></button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-3">
                        <div class="d-flex justify-content-between mb-3">
                            <button type="button" id="newListBtn" class="btn btn-primary btn-sm" aria-label={m.create_new_list()} onclick={createListHandler}>
                                <i class="bi bi-plus-lg" aria-hidden="true"></i> {m.new_list()}
                            </button>
                            <button type="button" id="removeListBtn" class="btn btn-outline-danger btn-sm {selectedList ? '' : 'disabled'}" aria-label={m.remove_selected_list()} onclick={() => selectedList && removeListHandler(selectedList.id)}>
                                <i class="bi bi-trash" aria-hidden="true"></i> {m.remove()}
                            </button>                          
                        </div>
                        <nav aria-label={m.auto_replace_lists()}>
                            <ul class="nav nav-pills flex-column" role="tablist">
                                {#await autoReplaceState}
                                    <div class="text-center py-3">
                                        <div class="spinner-border text-primary" role="status">
                                            <span class="visually-hidden">{m.loading()}</span>
                                        </div>
                                        <p class="mt-2 text-muted small">{m.loading_lists()}</p>
                                    </div>
                                {:then}                                
                                {#each autoReplaceState as list (list.id)}
                                    <li class="nav-item mb-2" role="presentation">
                                        <a class="nav-link d-flex justify-content-between align-items-center {selectedList && selectedList.id === list.id ? 'active' : ''}" 
                                           href="#!/"
                                           role="tab" 
                                           aria-selected={selectedList && selectedList.id === list.id}
                                           id="list-{list.id}"
                                           onclick={() => selectList(list)}>
                                           <span class="{list.enabled ? 'text-dark' : ''}">{list.name}</span>
                                           <div class="form-check m-0">
                                                <input class="form-check-input" 
                                                      type="checkbox" 
                                                      checked={list.enabled} 
                                                      onclick={() => toggleList(list)} 
                                                              aria-label={m.enable_disable_list({ name: list.name })}>
                                            </div>
                                        </a>
                                    </li>
                                {:else}
                                    <div class="text-center py-5">
                                        <i class="bi bi-file-earmark-plus text-muted fs-4"></i>
                                                <p class="text-muted small mt-2">{m.no_lists_available()}<br>{m.create_new_list_get_started()}</p>
                                    </div>
                                {/each}
                                {/await}
                            </ul>                        
                        </nav>
                    </div>
                    <div class="col-9">
                        {#if selectedList}
                        <div class="card mb-4">
                            <div class="card-header bg-light">
                                        <h5 class="card-title mb-0">{m.list_settings()}</h5>
                            </div>
                            <div class="card-body">
                                        <form onsubmit={preventDefault(()=>{updateList(selectedList, userId)})} aria-label={m.list_settings()}>
                                    <div class="mb-3">
                                                <label for="listNameInput" class="form-label">{m.list_name()}</label>
                                        <input id="listNameInput" type="text" class="form-control" bind:value={selectedList.name}/>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col-md-6">
                                            <div class="form-check form-switch">
                                                <input class="form-check-input" 
                                                       type="checkbox" 
                                                       id="EnableListCheck" 
                                                       bind:checked={selectedList.enabled}
                                                               aria-label={m.enable_list()}/>
                                                        <label class="form-check-label" for="EnableListCheck">{m.enable_this_list()}</label>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-check form-switch">
                                                <input class="form-check-input" type="checkbox" id="AutoUppercaseCheck" bind:checked={selectedList.uppercase}/>
                                                <label class="form-check-label" for="AutoUppercaseCheck">
                                                            {m.auto_uppercase()} <i class="bi bi-info-circle" title={m.auto_uppercase_help()}></i>
                                                </label>
                                            </div>                                    
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-end">
                                        <button type="button" class="btn btn-primary" onclick={() => updateList(selectedList, userId)}>
                                                    <i class="bi bi-check-lg me-1"></i> {m.save_changes()}
                                        </button>                    
                                    </div>
                                </form>
                            </div>
                        </div>
                        
                        <!-- Shortforms Table Card -->
                        <div class="card">
                            <div class="card-header bg-light d-flex justify-content-between align-items-center">
                                <h5 class="card-title mb-0">{m.shortform_replacements()}</h5>
                                <span class="badge bg-primary rounded-pill">{Object.keys(selectedList.replacements).length}</span>
                            </div>
                            <div class="card-body">
                                <div class="alert alert-warning py-2 mb-3" role="alert">
                                    <i class="bi bi-exclamation-triangle me-2"></i>
                                    <small>{m.avoid_real_words()}</small>
                                </div>
                                
                                <div class="input-group mb-3">
                                    <input type="text" bind:value={shortformInput} class="form-control" placeholder={m.shortform_text_placeholder()}>
                                    <input type="text" bind:value={replacementInput} class="form-control" placeholder={m.replacement_text_placeholder()}>
                                    <div class="input-group-append">
                                        {#if selectedReplacement}
                                            <button class="btn btn-info {shortformInput && replacementInput ? '' : 'disabled'}" onclick={() => updateShortform()} type="button" title={m.update_shortform()}>
                                                <i class="bi bi-check-lg"></i> {m.update()}
                                            </button>
                                            <button class="btn btn-secondary" onclick={() => cancelEdit()} type="button" title={m.cancel_update()}>
                                                {m.cancel()}
                                            </button>
                                        {:else}
                                            <button class="btn btn-primary {shortformInput && replacementInput ? '' : 'disabled'} rounded-start-0" onclick={() => addShortform()} type="button" title={m.add_shortform_to_list()}>
                                                <i class="bi bi-plus-lg"></i> {m.add()}
                                            </button>
                                        {/if}
                                    </div>
                                </div>
                                
                                <div class="table-responsive">
                                    <table class="table table-hover" aria-label={m.shortform_replacement_table()}>
                                        <thead class="table-light">
                                            <tr>                                        
                                                <th scope="col">{m.shortform()}</th>
                                                <th scope="col">{m.replacement()}</th>
                                                <th scope="col" class="text-end">{m.actions()}</th>
                                            </tr>
                                        </thead>
                                        <tbody>                                                        
                                            {#each Object.keys(selectedList.replacements).sort() as replacement}
                                                <tr>                                        
                                                    <td><code>{replacement}</code></td>
                                                    <td>{selectedList.replacements[replacement]}</td>
                                                    <td class="text-end">
                                                        <button aria-label={m.update_replacement()} class="btn btn-sm btn-outline-secondary me-1" type="button" title={m.edit()} onclick={()=> updateReplacement(replacement)}>
                                                            <i class="bi bi-pencil"></i>
                                                        </button>
                                                        <button class="btn btn-sm btn-outline-danger" type="button" title={m.delete()} aria-label={m.delete_shortform()} onclick={() => removeReplacement(replacement)}>
                                                            <i class="bi bi-trash"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            {:else}
                                                <tr>
                                                    <td colspan="3" class="text-center py-4 text-muted">
                                                        <i class="bi bi-clipboard-x fs-4 mb-2 d-block"></i>
                                                        {m.no_shortforms_added()}
                                                    </td>
                                                </tr>
                                            {/each}                                    
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        {:else}
                        <div class="d-flex flex-column justify-content-center align-items-center h-100 py-5">
                            <i class="bi bi-arrow-left-circle fs-1 text-muted mb-3"></i>
                            <p class="lead text-muted">{m.select_list_left()}</p>
                            <button class="btn btn-outline-primary mt-2" onclick={createListHandler}>
                                <i class="bi bi-plus-lg me-1"></i> {m.create_new_list()}
                            </button>
                        </div>
                        {/if}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<style lang="css">
    .modal-body {
        min-height: 70vh;
    }
    
    tbody {
        display: block;
        max-height: 300px;
        overflow-y: auto;
    }

    thead, tbody tr {
        display: table;
        width: 100%;
        table-layout: fixed;
    }
    
    .nav-pills .nav-link:not(.active) {
        color: #495057;
    }
    
    .nav-pills .nav-link {
        border-radius: 0.25rem;
        padding: 0.5rem 1rem;
        transition: all 0.2s;
    }
    
    .card {
        border-radius: 0.25rem;
        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
    }
    
    .card-header {
        border-bottom: 1px solid rgba(0, 0, 0, 0.125);
        padding: 0.75rem 1rem;
    }
    
    code {
        background-color: #f8f9fa;
        padding: 0.2rem 0.4rem;
        border-radius: 0.2rem;
    }
</style>